import type { BundleVariantsType } from '@/modals/modules/balances/+ShopModal/types/bundles';

export const getStylesBundleByVariant = (variant: BundleVariantsType) => {
  switch (variant) {
    case 'gamification':
    case 'promo':
      return {
        wrapperClassNames: 'pt-5 pb-4 bg-bundle-promo promo-bundle-stroke-border before:z-1!',
      };
    case 'vip':
      return {
        wrapperClassNames: 'p-4 pt-5 vip-stroke-border bg-bundle-vip before:z-1!',
      }
      ;
    default:
      return {
        wrapperClassNames: 'rounded-2xl glass-stroke-border shadow-card px-4 pb-3.5 pt-4.5 bg-header-gradient',
      }
      ;
  }
};
